import { PermisosUsuario } from '@core/types';
import { NavigationItem } from './navigation.types';

// TODO: Implement canShowItem and then define if can show collapsable or not
export const navigationData: NavigationItem[] = [
  {
    id: PermisosUsuario.estadisticas_informes,
    title: 'Estadísticas e informes',
    type: 'collapsable',
    link: '/dashboard',
    icon: 'ri-file-chart-line',
    children: [
      {
        id: 'estadisticas',
        title: 'Estadísticas',
        type: 'basic',
        link: '/dashboard/estadisticas',
      },
      {
        id: 'informes',
        title: 'Informes',
        type: 'basic',
        link: '/dashboard/informes',
      },
      {
        id: 'embeddable',
        title: 'Embeddable',
        type: 'basic',
        link: '/dashboard/embeddable',
        hidden: (item: NavigationItem) => {
          return localStorage.getItem('CodOrganizacion') !== '489';
        },
      },
    ],
  },
  {
    id: PermisosUsuario.manejo_inventario,
    title: 'Catálogo',
    type: 'collapsable',
    icon: 'ri-draft-line',
    link: '/catalogo/productos',
    children: [
      {
        id: 'productos',
        title: 'Productos y servicios',
        type: 'basic',
        link: '/catalogo/productos',
      },
      {
        id: 'productos',
        title: 'Productos compuestos',
        type: 'basic',
        link: '/catalogo/productos-compuestos',
      },
      {
        id: 'productos-grupo-productos',
        title: 'Grupo de productos adicionales',
        type: 'basic',
        link: '/catalogo/grupo-productos',
      },
      {
        id: 'productos',
        title: 'Materia prima',
        type: 'basic',
        link: '/catalogo/materia-prima',
      },
      {
        id: 'productos',
        title: 'Configuración de productos',
        type: 'basic',
        link: '/catalogo/configuracion-productos',
      },
    ],
  },
  {
    id: PermisosUsuario.gestion_compras,
    title: 'Inventario',
    type: 'collapsable',
    icon: 'ri-list-settings-line',
    link: '/inventario/gestion-inventario',
    children: [
      {
        id: 'gestion-inventario',
        title: 'Gestión inventario',
        type: 'basic',
        link: '/inventario/gestion-inventario',
      },
      {
        id: 'compras',
        title: 'Compras',
        type: 'basic',
        link: '/inventario/compras',
      },
      {
        id: 'proveedores',
        title: 'Proveedores',
        type: 'basic',
        link: '/inventario/proveedores',
      },
      {
        id: 'bodegas',
        title: 'Bodegas',
        type: 'basic',
        link: '/inventario/bodegas',
      },
      {
        id: 'documentos',
        title: 'Documentos',
        type: 'collapsable',
        children: [
          {
            id: 'requisiciones',
            title: 'Requisiciones',
            type: 'basic',
            link: '/documentos/requisiciones',
          },
          {
            id: 'ordenes-compra',
            title: 'Órdenes de compra',
            type: 'basic',
            link: '/documentos/ordenes-compra',
          },
          {
            id: 'facturas-compra',
            title: 'Facturas de compra',
            type: 'basic',
            link: '/documentos/facturas-compra',
          },
        ],
      }
    ],
  },
  {
    id: PermisosUsuario.manejo_clientes,
    title: 'Clientes',
    type: 'collapsable',
    icon: 'ri-service-line',
    link: '/clientes',
    children: [
      {
        id: 'clientes',
        title: 'Lista de clientes',
        type: 'basic',
        link: '/clientes',
      },
      {
        id: 'clientes',
        title: 'Configuración',
        type: 'basic',
        link: '/configuraciones-cliente',
      },
    ],
  },
  {
    id: PermisosUsuario.manejo_colaboradores,
    title: 'Colaboradores',
    type: 'collapsable',
    icon: 'ri-team-line',
    link: '/colaboradores',
    children: [
      {
        id: 'colaboradores.usuarios',
        title: 'Colaboradores',
        type: 'basic',
        link: '/colaboradores',
        exactMatch: true
      },
      {
        id: 'colaboradores.roles',
        title: 'Roles de colaborador',
        type: 'basic',
        link: '/colaboradores/roles',
      },
    ],
  },
  {
    id: PermisosUsuario.vista_bitacoras,
    title: 'Bitácoras',
    type: 'basic',
    icon: 'ri-todo-line',
    link: '/bitacoras',
  },
  {
    id: PermisosUsuario.configuracion_general,
    title: 'Configuraciones',
    type: 'collapsable',
    icon: 'ri-settings-3-line',
    link: '/configuraciones/ajustes-basicos',
    children: [
      {
        id: PermisosUsuario.ajustes_basicos,
        title: 'Configuración general',
        type: 'basic',
        link: '/configuraciones/ajustes-basicos',
      },
      {
        id: PermisosUsuario.integraciones,
        title: 'Integraciones',
        type: 'basic',
        link: '/configuraciones/integraciones',
      },
      {
        id: PermisosUsuario.configuracion_caja,
        title: 'Configuración de caja',
        type: 'basic',
        link: '/configuraciones/configuraciones-caja',
      },
    ],
  },
];

export const userMenuData: NavigationItem[] = [
  {
    id: 'profile',
    icon: 'person-circle-outline',
    title: 'Perfil',
    type: 'basic',
    link: '/profile',
  },
  {
    id: 'logout',
    svgIcon: 'assets/icons/user-shared-line 1.svg',
    title: 'Cerrar sesión',
    type: 'basic',
    link: '/sign-out',
  },
];
